import { Link } from "react-router-dom";

const benefits = [
  "Instant brand recognition in the AI food tech space",
  "Premium domain name with high memorability",
  "Perfect for food tech startups and established companies",
  "Ideal for AI-driven nutrition platforms",
  "Strong association with health, sustainability, and technology",
];

function DomainValue() {
  return (
    <section
      className="relative py-16 bg-green-900/60 bg-cover bg-center"
      style={{ backgroundImage: "url('/background2.png')" }}
    >
      {/* Full-width orange overlay */}
      <div className="absolute inset-0 bg-orange-900/60"></div>

      {/* Content Container - relative so it's above the overlay */}
      <div className="relative container mx-auto px-4">
        <div className="max-w-3xl mx-auto p-10 shadow-lg">
          <h2 className="text-3xl md:text-4xl text-white font-display font-bold text-center mb-8">
            Why Invest in{" "}
            <span className="text-primary-600">WholeFoods.ai</span>?
          </h2>

          <div className="bg-white rounded-xl p-8 shadow-md">
            <ul className="space-y-4">
              {benefits.map((benefit, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-primary-600 mr-3">✓</span>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 text-center">
              <Link
                to="/contact"
                className="inline-block px-8 py-3 bg-accent hover:bg-primary-700 rounded-lg text-white font-bold transition-colors shadow-md"
              >
                Inquire About Pricing
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DomainValue;
